import axios from 'axios'

const service = {
    getRegions () {
        return axios.get(`${process.env.VUE_APP_HYPER_V3_CONTENT}/region/region.json`)
    }
}

export {
    service
}
